import { useField } from 'formik'
import { FC, ReactNode } from 'react'

import { Checkbox } from '@components/Form/Checkbox'

import { CheckboxSwitchProps } from './CheckboxSwitch'

export type CheckboxSwitchFieldProps = Omit<CheckboxSwitchProps, 'onChange' | 'onBlur'> & {
  name: string
  label?: ReactNode
  isCell?: boolean
  accept?: 'boolean' | 'string'
  onChange?: (value: boolean) => void
}

export const CheckboxSwitchField: FC<CheckboxSwitchFieldProps> = ({
  name,
  accept = 'boolean',
  isCell,
  onChange,
  ...props
}) => {
  const [field, meta, helper] = useField(name)
  const checked = typeof field.value === 'boolean' ? field.value : field.value === 'true'

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    helper.setValue(accept === 'boolean' ? e.target.checked : '' + e.target.checked)
    if (onChange) {
      onChange(e.target.checked)
    }
  }

  return (
    <Checkbox
      {...props}
      onChange={handleChange}
      checked={checked}
      value={String(meta.initialValue)}
    />
  )
}
